import axios from 'axios';

import { BASE_URL, STORAGE_KEY_ACCESS_TOKEN } from '../const';
import storageService from './StorageService';

export class RequestsApi {
    constructor() {
        this.recursionCounter = 0;
    }

    async request(url, method, bodyObj = {}, customHeaders = {}, axiosOptions = {}) {
        const methodName = method.toLowerCase().trim();
        const accessToken = storageService.get(STORAGE_KEY_ACCESS_TOKEN);
        const requestUrl = `${BASE_URL}${url}`;
        let result = null;

        const config = {
            // HORO-10384: optional `timeout`, `signal`, etc. flow through here
            // so callers (chatApi.sendChatMessage) can apply per-request
            // axios options without each call rewriting the auth/header
            // handling. Headers are merged below so caller-supplied
            // options can't accidentally drop the Bearer token.
            ...axiosOptions,
            headers: {
                ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
                ...(!!customHeaders && customHeaders)
            }
        };
        const axiosParams = [];
        axiosParams.push(requestUrl);
        if (methodName === 'post' || methodName === 'put') {
            axiosParams.push(bodyObj);
        }
        axiosParams.push(config);
        try {
            result = await axios[methodName](...axiosParams);

            if (result && result.status >= 200 && result.status <= 299) {
                return result;
            }
        } catch (e) {
            if (e.response && e.response.status === 403) {
                storageService.delete(STORAGE_KEY_ACCESS_TOKEN);
            }
            if (e.response && e.response.status === 401) {
                const st = await RequestsApi.refreshAuthTokens();
                if (st && this.recursionCounter < 2) {
                    this.recursionCounter += 1;
                    return this.request(url, method, bodyObj, customHeaders, axiosOptions);
                }
                this.recursionCounter = 0;
                storageService.delete(STORAGE_KEY_ACCESS_TOKEN);
            }
            throw e;
        }
        return null;
    }

    static async refreshAuthTokens() {
        const refreshToken = storageService.get('refreshToken');
        if (!refreshToken) {
            return null;
        }
        try {
            const result = await axios.post(`${BASE_URL}/auth/refresh-token`, { refreshToken });
            return result;
        } catch (e) {
            return null;
        }
    }

    addResponseListener = (onFulfilled, onRejected = () => {}) => {
        return axios.interceptors.response.use(onFulfilled, onRejected);
    };
}
export default new RequestsApi();
